import { useCallback, useState } from 'react';
import { t } from 'services/localization';
import { usePayViaWallets } from 'shared/data/webApp/v2';
import { useItemsGroupedByWallet } from 'shared/hooks/(payments)';

export const usePayment = (
    companyId: string,
    requestId: string,
    lineItems: ReturnType<typeof useItemsGroupedByWallet>['enrichedLineItems'],
    onSuccessfulPayment: VoidFunction
) => {
    const [open, setOpen] = useState(false);

    const { mutate, isLoading } = usePayViaWallets({
        onSuccess: () => {
            setOpen(false);
            onSuccessfulPayment();
        },
    });

    const handleEnterCode = useCallback(
        (code: string) => {
            mutate({
                params: { path: { companyId, requestId } },
                body: {
                    oneTimePassword: code,
                    quoteIds: lineItems.map((lineItem) => ({
                        billInvoiceRequestId: lineItem.xeroBillInvoiceRequestId,
                        quoteId: lineItem.paymentQuote?.id || '',
                    })),
                },
            });
        },
        [companyId, lineItems, mutate, requestId]
    );

    const handlePay = useCallback(() => {
        setOpen(true);
    }, []);

    const handleSendCodeViaEmail = useCallback(() => {}, []);

    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    return {
        onPay: handlePay,
        twoFaActionWizardProps: {
            open,
            isLoading,
            title: t('authorise_the_payment'),
            onEnterAppCode: handleEnterCode,
            onEnterBackupCode: handleEnterCode,
            onEnterEmailCode: handleEnterCode,
            onSendCodeViaEmail: handleSendCodeViaEmail,
            onClose: handleClose,
        },
    };
};
